import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AccessContext = createContext(null);
const KEY = "bb_tutorial_access_token_v1";
const BID_KEY = "bb_brush_id_token_v1";

export function AccessProvider({ children }) {
  const [token, setTokenState] = useState(() => { try { return localStorage.getItem(KEY) || null; } catch { return null; } });
  const [bidToken, setBidTokenState] = useState(() => { try { return localStorage.getItem(BID_KEY) || null; } catch { return null; } });
  const [validated, setValidated] = useState(false);
  const [bidValidated, setBidValidated] = useState(false);

  useEffect(() => {
    if (!token) { setValidated(false); return; }
    api.post("/access/check", { token })
      .then((r) => {
        if (r.data?.valid) setValidated(true);
        else { setValidated(false); setTokenState(null); try { localStorage.removeItem(KEY); } catch {} }
      })
      .catch(() => setValidated(false));
  }, [token]);

  useEffect(() => {
    if (!bidToken) { setBidValidated(false); return; }
    api.post("/brush-id/access/check", { token: bidToken })
      .then((r) => {
        if (r.data?.valid) setBidValidated(true);
        else { setBidValidated(false); setBidTokenState(null); try { localStorage.removeItem(BID_KEY); } catch {} }
      })
      .catch(() => setBidValidated(false));
  }, [bidToken]);

  const setToken = useCallback((t) => {
    setTokenState(t);
    try { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); } catch {}
  }, []);

  const setBidToken = useCallback((t) => {
    setBidTokenState(t);
    try { if (t) localStorage.setItem(BID_KEY, t); else localStorage.removeItem(BID_KEY); } catch {}
  }, []);

  const unlocked = !!token && validated;
  const brushIdUnlocked = !!bidToken && bidValidated;

  const value = useMemo(() => ({
    token, unlocked, setToken,
    bidToken, brushIdUnlocked, setBidToken,
  }), [token, unlocked, setToken, bidToken, brushIdUnlocked, setBidToken]);

  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>;
}

export function useAccess() {
  const ctx = useContext(AccessContext);
  if (!ctx) throw new Error("useAccess must be inside AccessProvider");
  return ctx;
}
